module.exports = __webpack_public_path__ + "static/media/39-5.f1657d9b.mp3";